import { render, staticRenderFns } from "./AccountRegister.vue?vue&type=template&id=caaf995a&scoped=true"
import script from "./AccountRegister.vue?vue&type=script&lang=js"
export * from "./AccountRegister.vue?vue&type=script&lang=js"
import style0 from "./AccountRegister.vue?vue&type=style&index=0&id=caaf995a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caaf995a",
  null
  
)

export default component.exports